import React, { useState, useEffect } from 'react';
import { getMe, updateMembre, changePassword } from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import { FiUser, FiEdit2, FiLock, FiSave } from 'react-icons/fi';

const Profil = () => {
  const { user } = useAuth();
  const [profile, setProfile] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  const [coordForm, setCoordForm] = useState({ email: '', telephone: '', adresse: '' });
  const [coordSuccess, setCoordSuccess] = useState('');
  const [coordError, setCoordError] = useState('');
  const [coordSaving, setCoordSaving] = useState(false);

  const [pwdForm, setPwdForm] = useState({ current_password: '', new_password: '', confirm_password: '' });
  const [pwdSuccess, setPwdSuccess] = useState('');
  const [pwdError, setPwdError] = useState('');
  const [pwdSaving, setPwdSaving] = useState(false);

  useEffect(() => {
    getMe().then(r => {
      const u = r.data.user || r.data;
      setProfile(u);
      setCoordForm({ email: u.email || '', telephone: u.telephone || '', adresse: u.adresse || '' });
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const handleCoordSave = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!user) return;
    setCoordSaving(true);
    setCoordError('');
    try {
      await updateMembre(user.id, coordForm);
      setCoordSuccess('Coordonnées mises à jour avec succès');
      setTimeout(() => setCoordSuccess(''), 3000);
    } catch (err: any) {
      setCoordError(err.response?.data?.error || 'Erreur lors de la mise à jour');
      setTimeout(() => setCoordError(''), 3000);
    }
    setCoordSaving(false);
  };

  const handlePwdSave = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!user) return;
    setPwdError('');
    if (pwdForm.new_password !== pwdForm.confirm_password) {
      setPwdError('Les mots de passe ne correspondent pas');
      setTimeout(() => setPwdError(''), 3000);
      return;
    }
    if (pwdForm.new_password.length < 4) {
      setPwdError('Le mot de passe doit contenir au moins 4 caractères');
      setTimeout(() => setPwdError(''), 3000);
      return;
    }
    setPwdSaving(true);
    try {
      await changePassword(user.id, { current_password: pwdForm.current_password, new_password: pwdForm.new_password });
      setPwdSuccess('Mot de passe modifié avec succès');
      setPwdForm({ current_password: '', new_password: '', confirm_password: '' });
      setTimeout(() => setPwdSuccess(''), 3000);
    } catch (err: any) {
      setPwdError(err.response?.data?.error || 'Erreur lors du changement de mot de passe');
      setTimeout(() => setPwdError(''), 3000);
    }
    setPwdSaving(false);
  };

  if (loading) return <div>Chargement...</div>;
  if (!profile) return <div>Erreur de chargement du profil</div>;

  return (
    <div>
      <h1 className="page-title">Mon profil</h1>

      <div className="grid-2">
        {/* Left: Read-only info */}
        <div className="card">
          <div className="card-header">
            <span><FiUser /> Informations personnelles</span>
          </div>
          <div className="card-body">
            <div className="info-list">
              <div className="info-row"><span className="info-label">Nom complet</span><span className="info-value">{profile.prenomnom || '-'}</span></div>
              <div className="info-row"><span className="info-label">Matricule</span><span className="info-value">{profile.matricule || '-'}</span></div>
              <div className="info-row"><span className="info-label">Sexe</span><span className="info-value">{profile.sexe === 'M' ? 'Masculin' : profile.sexe === 'F' ? 'Féminin' : profile.sexe || '-'}</span></div>
              <div className="info-row"><span className="info-label">Date de naissance</span><span className="info-value">{profile.datenaissance ? new Date(profile.datenaissance).toLocaleDateString('fr-FR') : '-'}</span></div>
              <div className="info-row"><span className="info-label">Lieu de naissance</span><span className="info-value">{profile.lieunaissance || '-'}</span></div>
              <div className="info-row"><span className="info-label">CNI</span><span className="info-value">{profile.cni || '-'}</span></div>
              <div className="info-row"><span className="info-label">Service</span><span className="info-value">{profile.service || '-'}</span></div>
              <div className="info-row"><span className="info-label">Corps</span><span className="info-value">{profile.corps || '-'}</span></div>
            </div>
          </div>
        </div>

        {/* Right column */}
        <div>
          {/* Editable contact form */}
          <div className="card">
            <div className="card-header">
              <span><FiEdit2 /> Modifier mes coordonnées</span>
            </div>
            <div className="card-body">
              {coordSuccess && <div className="alert alert-success">{coordSuccess}</div>}
              {coordError && <div className="alert alert-error">{coordError}</div>}
              <form onSubmit={handleCoordSave}>
                <div className="form-group">
                  <label>Email</label>
                  <input type="email" className="form-input" value={coordForm.email} onChange={e => setCoordForm({ ...coordForm, email: e.target.value })} />
                </div>
                <div className="form-group">
                  <label>Téléphone</label>
                  <input type="text" className="form-input" value={coordForm.telephone} onChange={e => setCoordForm({ ...coordForm, telephone: e.target.value })} />
                </div>
                <div className="form-group">
                  <label>Adresse</label>
                  <textarea className="form-input" rows={3} value={coordForm.adresse} onChange={e => setCoordForm({ ...coordForm, adresse: e.target.value })} />
                </div>
                <button type="submit" className="btn btn-primary" disabled={coordSaving}>
                  <FiSave /> {coordSaving ? 'Enregistrement...' : 'Enregistrer'}
                </button>
              </form>
            </div>
          </div>

          {/* Password change form */}
          <div className="card" style={{ marginTop: '1.5rem' }}>
            <div className="card-header">
              <span><FiLock /> Changer le mot de passe</span>
            </div>
            <div className="card-body">
              {pwdSuccess && <div className="alert alert-success">{pwdSuccess}</div>}
              {pwdError && <div className="alert alert-error">{pwdError}</div>}
              <form onSubmit={handlePwdSave}>
                <div className="form-group">
                  <label>Mot de passe actuel</label>
                  <input type="password" className="form-input" value={pwdForm.current_password} onChange={e => setPwdForm({ ...pwdForm, current_password: e.target.value })} required />
                </div>
                <div className="form-group">
                  <label>Nouveau mot de passe</label>
                  <input type="password" className="form-input" value={pwdForm.new_password} onChange={e => setPwdForm({ ...pwdForm, new_password: e.target.value })} required />
                </div>
                <div className="form-group">
                  <label>Confirmer le mot de passe</label>
                  <input type="password" className="form-input" value={pwdForm.confirm_password} onChange={e => setPwdForm({ ...pwdForm, confirm_password: e.target.value })} required />
                </div>
                <button type="submit" className="btn btn-primary" disabled={pwdSaving}>
                  <FiLock /> {pwdSaving ? 'Modification...' : 'Modifier le mot de passe'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profil;
